import { Organization } from '@paragon/contract-library';

import { AuthorizationApi } from './connections';

export function pGetOrganization(organizationName: string): Promise<Organization> {
  return AuthorizationApi.get(`organizations/${organizationName}`);
}

export async function pGetCustomers(organizationName: string) {
  const data = await AuthorizationApi.get<Organization>(`organizations/${organizationName}/customers`);
  return data.customers;
}
